<template>
    <div class="gift-eggs-layer">
        <div class="mask" :class="isShow?'mask-show':'mask-hide'"></div>
        <div class="gift-eggs-box abs-mm" :class="isShow?'mask-show':'mask-hide'">
            <div class="egg-title"></div>
            <div class="egg">
                <div class="egg-top" id="eggTop"></div>
                <div class="egg-bottom"></div>
                <div class="egg-light"></div>
                <div class="egg-stars"></div>
                <template v-if="giftEggType=='1'">
                    <div class="egg-button" @click="layerHide" clstag="A05R|clk_tc_hby_get"></div>
                </template>
                <template v-if="giftEggType=='2'">
                    <div class="egg-button" @click="layerHide" clstag="A05R|clk_tc_fbk_get"></div>
                </template>
                <template v-if="giftEggType=='3'">
                    <div class="egg-button" @click="layerHide"
                         :clstag="`A05R|clk_tc_egg${giftEggNum}_get`"></div>
                </template>
                <div class="egg-gift">
                    <div class="egg-gift-content">
                        <template v-if="giftEggType=='1'">
                            <div class="egg-gift-desc">恭喜您！获得"提鹅收蛋花瓣雨"道具！</div>
                            <div class="egg-gift-icon-1"></div>
                            <div class="egg-gift-txt ta-c">（有效期3天）</div>
                        </template>
                        <template v-if="giftEggType=='2'">
                            <div class="egg-gift-desc">恭喜您！获得"翻倍卡"道具！</div>
                            <div class="egg-gift-icon-2"></div>
                            <div class="egg-gift-txt ta-c">（有效期3天）</div>
                        </template>
                        <template v-if="giftEggType=='3'">
                            <div class="egg-gift-desc">恭喜您！获得 <span class="udc-bold">{{giftEggNum}}</span>枚 鹅蛋奖励！</div>
                            <div class="egg-gift-3">
                                <div class="egg-gift-icon-3"></div>
                                <div class="egg-gift-num udc-bold">x {{giftEggNum}}</div>
                            </div>
                        </template>
                    </div>
                    <div class="gift-board-text">
                        <!--<div v-if="tryTime">今日部分用户试行一天</div>-->
                        <h6>2020.5.21-6.18 周二至周四每日首次打开参与</h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {gsap} from "gsap";

    export default {
        data() {
            return {
                isShow: true
            }
        },
        props: {
            giftEggType: Number,
            giftEggNum: Number
        },
        mounted() {
            this.playAnim();
        },
        computed: {
            tryTime() {
                let date = new Date();
                if (date.getTime() >= 1590451200000) {
                    return false
                } else {
                    return true;
                }
            },
        },
        methods: {
            layerHide() {
                this.isShow = false;
                setTimeout(() => {
                    this.$emit('layer-hide');
                    if (this.giftEggType == 3) {
                        this.$emit('add-eggs', this.giftEggNum);
                    }
                }, 300)

            },
            playAnim() {
                let masterTl = gsap.timeline();
                masterTl
                    .add(this.eggIn())
                    .add(this.eggShake())
                    .add(this.eggOpen(), '-=2.4')
                    .add(this.lightRotation(), '-=0.5')
                    .add(this.resultShow(), '-=40')
            },
            eggIn() {
                let tl = gsap.timeline();
                tl
                    .from('.egg', {y: 1500, duration: 0.5})
                    .from('.egg-title', {y: -1500, duration: 0.5}, '-=0.5')
                return tl;
            },
            eggShake() {
                let tl = gsap.timeline({repeat: 3, repeatDelay: 0, yoyo: true});
                tl.to('.egg-top', {y: -5, duration: 0.15})
                    .to('.egg-top', {rotation: -5, duration: 0.15})
                    .to('.egg-top', {rotation: 5, duration: 0.15})
                    .to('.egg-top', {rotation: 0, duration: 0.15});
                return tl;
            },
            eggOpen() {
                let tl = gsap.timeline();
                tl
                    .to('.egg', {rotation: -2, duration: 0.5})
                    .to('.egg', {rotation: 2, duration: 0.5})
                    .to('.egg', {rotation: 0, duration: 0.5})
                    .to('.egg-top', {y: -50, duration: 0.3}, '+=1')
                    .to('.egg-stars', {opacity: 1, scale: 1, duration: 0.3, ease: 'linear'}, '-=0.3')
                    .to('.egg-stars', {opacity: 0, scale: 5, duration: 0.5, ease: 'linear'})
                    .to('.egg-light', {opacity: 1, scale: 1, duration: 0.5}, '-=0.8')

                return tl;
            },
            lightRotation() {
                let tl = gsap.timeline({repeat: -1, repeatDelay: 0});
                tl
                    .to('.egg-light', {rotation: 360, duration: 40, ease: 'linear'})
                return tl;
            },
            resultShow() {
                let tl = gsap.timeline();
                tl
                    .to('.egg-title', {y: -300, scale: 2, opacity: 0, duration: 1})
                    .to('.egg-top', {y: -300, scale: 2, opacity: 0, duration: 0.8}, '-=1')
                    .to('.egg-bottom', {y: 300, scale: 2, opacity: 0, duration: 0.8}, '-=1')
                    .to('.egg-light', {y: '-0.8rem', duration: 0.3}, '-=0.8')
                    .to('.egg-gift', {scale: 1, duration: 0.6, y: '-1rem', ease: 'back.out(1.7)'}, '-=1')
                    .to('.egg-button', {scale: 1, duration: 0.6, y: '1rem'}, '-=1')

                return tl;
            }
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss">
    .gift-eggs-layer {position: fixed;left: 0;top: 0;width: 100%;height: 100%; z-index: 30;
        .mask {position: absolute;left: 0;top: 0;bottom: 0;right: 0;margin: auto;width: 100%;height: 100%;background: rgba(0, 0, 0, 0.8);}
        .mask-show {animation: maskShow 0.3s 1 ease-out both;}
        .mask-hide {animation: maskHide 0.3s 1 ease-out both;}
        .gift-eggs-box {width: 100%;height: 4rem;}
        .egg {position: absolute;width: 2.2rem;height: 2.6rem;left: 50%;margin-left: -1.1rem;top: 1.3rem;}
        .egg-title {position: absolute;width: 3.04rem;height: 1.28rem;top: 0;left: 50%;margin-left: -1.52rem;background-image: url('#{$path}/giftEggs/title.png');@include singleBg;}
        .egg-top {width: 2.2rem;height: 2.6rem;background-image: url('#{$path}/giftEggs/egg-top.png');@include singleBg;}
        .egg-bottom {position: absolute;left: 0;top: 0;width: 2.2rem;height: 2.6rem;background-image: url('#{$path}/giftEggs/egg-bottom.png');@include singleBg;}
        .egg-light {position: absolute;width: 3.68rem;height: 4.62rem;background-image: url('#{$path}/giftEggs/light.png');@include singleBg;left: 50%;margin-left: -1.84rem;top: 50%;margin-top: -2.5rem;opacity: 0;transform: scale(0)}
        .egg-stars {position: absolute;width: 3.22rem;height: 2.94rem;background-image: url('#{$path}/giftEggs/star.png');@include singleBg;left: 50%;margin-left: -1.61rem;top: 50%;margin-top: -1.47rem;opacity: 0;transform: scale(0)}
        .egg-gift {position: absolute;width: 3.15rem;height: 3.26rem;background-image: url('#{$path}/giftEggs/gift-board.png');@include singleBg;left: 50%;margin-left: -1.52rem;top: 50%;margin-top: -1.63rem;transform: scale(0)}
        .egg-button {position: absolute;width: 2.55rem;height: 0.5rem;background-image: url('#{$path}/giftEggs/gift-btn.png');@include singleBg;left: 50%;margin-left: -1.28rem;top: 50%;margin-top: -0.2rem;transform: scale(0)}
        .egg-gift-content {position: absolute;width: 100%;height: 1.3rem;left: 0;bottom: 0.5rem;}
        .egg-gift-desc {color: #fff;font-size: 0.18rem;}
        .egg-gift-icon-1 {width: 1.32rem;height: 0.76rem;background-image: url(#{$path}/giftEggs/gift-item-1.png);@include singleBg;margin: 0 auto;margin-top: 0.05rem;}
        .egg-gift-icon-2 {width: 1.32rem;height: 0.76rem;background-image: url(#{$path}/giftEggs/gift-item-2.png);@include singleBg;margin: 0 auto;margin-top: 0.05rem;}
        .egg-gift-3 {height: 1rem;width: 100%;display: flex;align-items: center;justify-content: center;}
        .egg-gift-icon-3 {width: 0.49rem;height: 0.62rem;background-image: url(#{$path}/giftEggs/gift-item-3.png);@include singleBg}
        .egg-gift-num {font-size: 0.44rem;color: #fff;margin-left: 0.1rem;}
        .egg-gift-txt {color: #fff;opacity: 0.6;font-size: 0.12rem;margin-top: 0.02rem;}
        .gift-board-text {text-align: center;margin-top: 0.05rem;position: absolute;width: 100%;bottom: 0.1rem;
            color: #AF9EFF;font-size: 0.12rem;
            h6 {color: #ffdfbb;}
            }
        }
</style>